<template>
  <div class='sub-content'> <!-- 여기까지 page header 이하 수정해서 사용-->
    <dx-data-grid ref='refDokubGrid'
      :data-source='doKubInfoList'
      :show-borders = 'true' :showRowLines = 'false' :showColumnLines='true'
      :hover-state-enabled = "true" :allowColumnResizing = 'true'
      column-resizing-mode = 'widget' :allow-column-reordering = "true"
      :height='gridHeight' :row-alternation-enabled="true"
      :focused-row-enabled="true"
      @focused-row-changed="onSelectionChanged"
      :auto-navigate-to-focused-row="false"
      key-expr="품번"
      @toolbar-preparing='onToolbarPreparing'
    >
      <DxGrouping :auto-expand-all="isExpandAll"/>
      <DxSearchPanel
        :visible="true"
        placeholder="검색..."
      />
      <DxExport
        :enabled="true"
        :file-name="excelFileName"
      />
      <DxFilterRow
        :visible="true"
        apply-filter="auto"
      />
      <DxColumn
        :group-index="0"
        data-field="도급업체"
      />
      <DxColumn
        :allowEditing='false'
        caption="도급업체"
        data-field="거래처코드"
        :visible='true'
        width='80'
      >
        <DxLookup
          :data-source="partnerLookup"
          display-expr="거래처명"
          value-expr="거래처코드"
        />
      </DxColumn>
      <DxColumn
        v-if="$store.getters.getGroupName !== null"
        :caption="$store.getters.getGroupName"
        data-field="차종"
        width="80"
        sort-order="asc"
      >
      </DxColumn>
      <DxColumn
        :allowEditing='true'
        caption="품번"
        data-field="품번"
        sort-order="asc"
      >
      </DxColumn>
      <DxColumn
        :allowEditing='true'
        caption="품명"
        data-field="품명"
      >
      </DxColumn>
      <DxColumn
        :allowEditing='false'
        caption="품목유형"
        data-field="품목유형"
        :visible='true'
        width='80'
      >
        <DxLookup
          :data-source="itemTypeLookup"
          display-expr="코드명"
          value-expr="코드"
        />
      </DxColumn>
      <DxColumn
        :allowEditing='false'
        caption="공정유형"
        data-field="공정유형"
        :visible='true'
        width='80'
      >
        <DxLookup
          :data-source="processingTypeLookup"
          display-expr="코드명"
          value-expr="코드"
        />
      </DxColumn>
      <DxColumn
        :allowEditing='true'
        caption="라인명"
        data-field="라인코드"
        :visible='true'
      >
        <DxLookup
          :data-source="productionLineLookup"
          display-expr="라인명"
          value-expr="라인코드"
        />
      </DxColumn>
      <DxColumn
        :allowEditing="true"
        caption="월계획"
        data-field="월계획"
        :visible='true'
        dataType="number"
        format='#,##0'
      >
      </DxColumn>
      <DxColumn
        :allowEditing="true"
        caption="납품수량"
        data-field="납품수량"
        :visible='true'
        dataType="number"
        format='#,##0'
      >
      </DxColumn>
      <DxColumn
        :allowEditing="true"
        caption="%"
        :calculate-cell-value="calcRate"
        :visible='true'
        dataType="number"
        format="#0%"
        width="80"
      >
      </DxColumn>
      <DxColumn
        :allowEditing="true"
        caption="도급단가"
        data-field="외주가공비"
        :visible='true'
        dataType="number"
        format='#,##0.00'
      >
      </DxColumn>
      <DxColumn
        :allowEditing="true"
        caption="월계획비용"
        :calculate-cell-value="calcPlanDokub"
        data-field="월계획비용"
        :visible='true'
        dataType="number"
        format='#,##0'
      >
      </DxColumn>
      <DxColumn
        :allowEditing="true"
        caption="월납품도급비용"
        data-field="도급비용"
        :visible='true'

        dataType="number"
        format='#,##0'
      >
      </DxColumn>
      <DxSummary>
        <DxGroupItem
          column="품번"
          summary-type="count"
          display-format="{0} 건"
        />
        <DxGroupItem
          :show-in-group-footer="false"
          :align-by-column="true"
          value-format='#,##0'
          summary-type="sum"
          column="월계획비용"
          display-format="{0}"
        />
        <DxGroupItem
          :show-in-group-footer="false"
          :align-by-column="true"
          value-format='#,##0'
          summary-type="sum"
          column="도급비용"
          display-format="{0}"
        />
      </DxSummary>
      <DxSortByGroupSummaryInfo summary-item="count"/>
      <DxMasterDetail
        :enabled="true"
        template="dokubDetailTemplate"
      />
      <template #dokubDetailTemplate="{ data: item }">
        <DoKubDetailSubGrid :item=item :baseDate="baseDate" @refresh-detail-completed="onRefreshDetailCompleted"
          :productionLineLookup="productionLineLookup"
        />
      </template>
      <dx-paging :enabled="false"/>
      <dx-scrolling mode="virtual" showScrollbar='always' :useNative='false'/>
      <dx-sorting mode="multiple"/>
      <template #last-update-date>
        <div class="toolbar-label" style='font-size:1.2rem;margin-left:10px;'>
          <b> 마지막 마감일 : {{lastUpdateDate}} </b>
        </div>
      </template>
    </dx-data-grid>
    <loading :active.sync="isLoading" color='rgb(2, 110, 156)' loader='bars'></loading>
  </div> <!--sub-conten end-->
</template>

<script>
import Loading from 'vue-loading-overlay'
import ConstDef from '../../share/ConstDef'
import AppLib from '../../share/AppLib'
import DxDataGrid, {
  DxScrolling, DxFilterRow, DxExport, DxMasterDetail,
  DxColumn, DxPaging, DxSorting, DxSearchPanel, DxLookup,
  DxSummary, DxGroupItem, DxSortByGroupSummaryInfo, DxGrouping
} from 'devextreme-vue/data-grid'
import DoKubDetailSubGrid from './DoKubDetailSubGrid'
import HttpService from '../../share/service/HttpService'
// import axios from 'axios'

export default {
  name: 'DoKubSummary',
  data: function () {
    return {
      isLoading: false,
      userInfo: null,
      gridHeight: null,
      excelFileName: null,
      selectedRow: null,
      doKubInfoList: null,
      yearArray: [],
      thisYear: null,
      monthArray: [],
      thisMonth: null,
      productionLineLookup: null,
      processingTypeLookup: null,
      itemTypeLookup: null,
      isExpandAll: true,
      monthCompleteBtn: null,
      selectedRowBefore: 'init',
      baseDate: null,
      partnerLookup: null,
      lastUpdateDate: null,
      doKubDate: null
    }
  },
  components: {
    Loading,
    DxDataGrid,
    DxScrolling,
    DxFilterRow,
    DxExport,
    DxColumn,
    DxPaging,
    DxSorting,
    DxSearchPanel,
    DxLookup,
    DxMasterDetail,
    DxSummary,
    DxGroupItem,
    DxSortByGroupSummaryInfo,
    DxGrouping,
    DoKubDetailSubGrid
  },
  created () {
    document.title = ConstDef.WEB_TAB_TITLE
    this.userInfo = this.$store.getters.getUserInfo
    if (this.userInfo === null) {
      this.$router.push('/')
      return
    }
    this.doKubDate = `${AppLib.calcMonthFromToday(-1).substring(0, 7)}`
    this.itemTypeLookup = this.$store.getters.getBaseDataByType(ConstDef.품목유형)
    this.processingTypeLookup = this.$store.getters.getBaseDataByType(ConstDef.공정유형)
    this.partnerLookup = this.$store.getters.getPartnersInfo
    // console.log(this.partnerLookup)
  },
  mounted () {
    this.init()
    this.gridHeight = (screen.height - 250) * 0.95
  },
  updated () {
  },
  beforeDestroy: function () {

  },
  methods: {
    calcRate (row) {
      if (row.월계획 < 0) {
        return null
      }
      return row.납품수량 / row.월계획
    },
    calcPlanDokub (row) {
      return row.외주가공비 * row.월계획
    },
    disabledClosedBtn (bseDate) {
      let lastMonth = `${AppLib.getToday().substring(0, 7)}-01`
      lastMonth = `${AppLib.calcDateFromFormat(lastMonth, -1).substring(0, 7)}-01`
      if (bseDate <= lastMonth) {
        this.monthCompleteBtn.option({ disabled: true })
      } else {
        this.monthCompleteBtn.option({ disabled: false })
      }
    },
    init () {
      this.refreshLine()
      this.refreshDoKubResult()
    },
    onSelectionChanged (e) {
      if (e != null && e.row === undefined) {
        return
      }
      if (e !== null) {
        this.selectedRow = e.row.data
      }
    },
    onToolbarPreparing (e) {
      e.toolbarOptions.items.unshift(
        {
          location: 'before',
          template: function () {
            return `<div class="toolbar-label" style='margin-left:4px;color:rgb(4, 103, 189);'><b>마감월 :  </b></div>`
          }
        },
        {
          location: 'before',
          widget: 'dxDateBox',
          options: {
            width: 80,
            value: this.doKubDate,
            type: 'date',
            calendarOptions: {
              maxZoomLevel: 'year',
              minZoomLevel: 'century'
            },
            max: `${AppLib.calcMonthFromToday(0).substring(0, 7)}`,
            dateSerializationFormat: 'yyyy-MM',
            displayFormat: 'yyyy-MM',
            onValueChanged: (args) => {
              console.log(args.value)
              this.doKubDate = args.value
              this.refreshDoKubResult()
            }
          }
        },
        {
          location: 'after',
          template: 'last-update-date'
        },
        {
          location: 'after',
          widget: 'dxButton',
          options: {
            hint: '해당월마감',
            icon: 'add',
            text: '해당월마감',
            type: 'default',
            focusStateEnabled: true,
            onInitialized: (args) => {
              this.monthCompleteBtn = args.component
            },
            onClick: (args) => {
              console.log(this.baseDate.fromDate)
              if (`${AppLib.getToday().substring(0, 7)}-01` <= this.baseDate.fromDate) {
                this.$snotify.info('현재월은 마감할 수 없습니다.')
                return
              }
              this.$snotify.confirm('월마감 후 현 도급 단가로 마감 되며 마감 후 작용된 도급 단가는 수정할 수 없습니다.', '', {
                timeout: 10000,
                showProgressBar: true,
                closeOnClick: false,
                pauseOnHover: true,
                buttons: [
                  {
                    text: '월마감',
                    action: async (toast) => {
                      this.$snotify.remove(toast.id)
                      this.baseDate.createId = this.userInfo.userId
                      if (this.lastUpdateDate !== null) {
                        await HttpService.reqPostBody(this.$_sp.makeParamModel(this.baseDate), '/saveMrpV2')
                          .then(() => {
                            console.log('재계산')
                          })
                      }
                      this.$_sp.runUpdateProc('spUpdateDokubCompleteByDateV2', [this.baseDate])
                        .then(data => {
                          this.$snotify.info('마감 되었숩니다.')
                          console.log('재계산왼료')
                          this.refreshDoKubResult()
                        })
                        .catch(error => {
                          this.isLoading = false
                          if (error.response.status === ConstDef.GENERRAL_ERROR) {
                            this.$snotify.error(error.response.data.message)
                          } else {
                            this.$snotify.error(`에러코드 : ${error.response.status}`)
                          }
                        })
                    }
                  },
                  {
                    text: '취소',
                    action: (toast) => {
                      this.$snotify.remove(toast.id)
                    }

                  }
                ]
              })
            }
          }
        }
      )
    },
    async refreshDoKubResult () {
      let date = this.doKubDate.split('-')
      this.excelFileName = `${this.doKubDate}월_도급생산현황`
      this.baseDate = {
        title: `${this.doKubDate}월 납품수량`,
        fromDate: `${this.doKubDate}-01`,
        toDate: `${this.doKubDate}-${AppLib.getMonthLastDay(date[0], date[1])} 23:59:59`
      }
      await this.$_sp.runNoEncodeFindSqlProc('도급월마감', { 납품기준월: this.baseDate.fromDate })
        .then((data) => {
          this.doKubInfoList = this.$_sp.MakeModel(data)
          this.lastUpdateDate = this.doKubInfoList.length !== 0 ? AppLib.formatDateTimeFromTimeStamp(this.doKubInfoList[0].createTime) : null
        })
      if (this.doKubInfoList.length === 0) {
        this.isLoading = true
        HttpService.reqPostBody(this.$_sp.makeParamModel(this.baseDate), '/saveMrpV2')
          .then((data) => {
            this.$snotify.info('도급내역을 조회하고 있습니다.', { timeout: 300 })
            this.$_sp.runNoEncodeFindProc('spFindAllDoKupBillByDateGbyGoodsNo', this.baseDate)
              .then((data) => {
                this.isLoading = false
                this.doKubInfoList = this.$_sp.MakeModel(data)
                this.monthCompleteBtn.option({ disabled: false })
              })
              .catch(error => {
                this.isLoading = false
                if (error.response.status === ConstDef.GENERRAL_ERROR) {
                  this.$snotify.error(error.response.data.message)
                } else {
                  this.$snotify.error(`에러코드 : ${error.response.status}`)
                }
              })
          })
          .catch(error => {
            this.isLoading = false
            if (error.response.status === ConstDef.GENERRAL_ERROR) {
              this.$snotify.error(error.response.data.message)
            } else {
              this.$snotify.error(`에러코드 : ${error.response.status}`)
            }
          })
      }
    },
    refreshLine () {
      this.$_sp.runNoEncodeFindSqlProc('생산라인', null)
        .then((data) => {
          this.productionLineLookup = this.$_sp.MakeModel(data)
        })
        .catch(error => {
          this.isLoading = false
          if (error.response.status === ConstDef.GENERRAL_ERROR) {
            this.$snotify.error(error.response.data.message)
          } else {
            this.$snotify.error(`에러코드 : ${error.response.status}`)
          }
        })
    },
    // Detail subcell
    onRefreshDetailCompleted () {
      if (this.selectedRowBefore !== null) {
        this.$refs.refDokubGrid.instance.collapseRow(this.selectedRowBefore)
        this.selectedRowBefore = this.selectedRow.품번
      }
      // this.$refs.refDokubGrid.instance.expandRow(this.focusedRowKey)
    }
  }
}
</script>

<style lang="scss">
</style>
